module.exports = __webpack_public_path__ + "img/bg2.c3f1ff41.jpg";